module.exports = __webpack_public_path__ + "img/Skirt-Back-B6-Da-Fb-Gc-Hc.db883c65.png";